<template lang="html">

  <section class="home">

    <encabezado :data="'home'"></encabezado>

    <home-empresa v-if="isEmpresa"></home-empresa>

    <home-alumno v-if="isAlumno"></home-alumno>

    <div class="galeria">
        <img src="/static/img/brands/educaedtech/publi/logo-publi-1.png" alt="Logo" class="logo-publi">
        <img src="/static/img/brands/educaedtech/publi/logo-publi-2.png" alt="Logo" class="logo-publi">
        <img src="/static/img/brands/educaedtech/publi/logo-publi-3.png" alt="Logo" class="logo-publi">
        <img src="/static/img/brands/educaedtech/publi/logo-publi-4.png" alt="Logo" class="logo-publi">
        <img src="/static/img/brands/educaedtech/publi/logo-publi-5.png" alt="Logo" class="logo-publi">
        <img src="/static/img/brands/educaedtech/publi/logo-publi-6.png" alt="Logo" class="logo-publi">
        <!-- <img src="/static/img/brands/educaedtech/publi/logo-publi-7.png" alt="Logo" class="logo-publi"> -->
        <!-- <img src="/static/img/brands/educaedtech/publi/logo-publi-8.png" alt="Logo" class="logo-publi"> -->
        <img src="/static/img/brands/educaedtech/publi/logo-publi-9.png" alt="Logo" class="logo-publi">
        <img src="/static/img/brands/educaedtech/publi/logo-publi-10.png" alt="Logo" class="logo-publi">
        <!-- <img src="/static/img/brands/educaedtech/publi/logo-publi-11.png" alt="Logo" class="logo-publi"> -->
        <!-- <img src="/static/img/brands/educaedtech/publi/logo-publi-12.png" alt="Logo" class="logo-publi"> -->
        <img src="/static/img/brands/educaedtech/publi/logo-publi-13.png" alt="Logo" class="logo-publi">
        <!-- <img src="/static/img/brands/educaedtech/publi/logo-publi-14.png" alt="Logo" class="logo-publi"> -->
        <!-- <img src="/static/img/brands/educaedtech/publi/logo-publi-15.png" alt="Logo" class="logo-publi"> -->
        <!-- <img src="/static/img/brands/educaedtech/publi/logo-publi-16.png" alt="Logo" class="logo-publi"> -->
    </div>

   

  </section>

</template>

<script lang="js">

  import homeAlumno from '@/components/views/home/home-alumno';
  import homeEmpresa from '@/components/views/home/home-empresa';


  import encabezado from '@/components/parts/encabezado';

  import {mapGetters,mapActions} from 'vuex'

  export default  {
    name: 'home',
    mounted(){
      if(!!!this.logged){
        this.logout();
      }
    },
    computed: {
      ...mapGetters({
        isAlumno: 'isAlumno' ,
        isEmpresa: 'isEmpresa',
        logged : 'getLogged'
      })
    },  
    methods : {
      ...mapActions(['logout'])
    },
    components :{
      'home-alumno' : homeAlumno,
      'home-empresa' : homeEmpresa,
      'encabezado' : encabezado,
    }
  }
</script>

<style scoped lang="scss">


  .galeria {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    max-width: 960px;
    margin: auto;
    justify-content: center;
    margin-top: 40px;
  }

  .galeria img {
    width: 200px;       /* Ancho fijo */
    height: auto;       /* Mantiene relación de aspecto */
    object-fit: contain;/* Alternativa: cover si prefieres llenar el espacio */
    display: block;
    margin: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/home/home.vue